export default "__VITE_ASSET__2uE24ACY__"